/**
 * Formats ROID value for display in tables
 * Handles both array and string formats safely
 * @param roidValue - The ROID value from table cell
 * @returns Formatted ROID string
 */
export const formatRoidForDisplay = (roidValue: unknown): string => {
  if (Array.isArray(roidValue)) {
    return roidValue.join('.');
  } else if (typeof roidValue === 'string') {
    return roidValue;
  }
  return '';
};

/**
 * Formats a ROID string by adding dots between segments.
 * Input: "At0000057000102" or array ["At", "0000057", "0000", "02"]
 * Output: "At.0000057.0000.02"
 * @param roidValue - The ROID value to format
 * @returns Formatted ROID string with dots
 */
export const formatRoidWithDots = (roidValue: unknown): string => {
  if (Array.isArray(roidValue)) {
    return roidValue.join('.');
  }

  if (typeof roidValue === 'string') {
    // If already has dots, return as-is
    if (roidValue.includes('.')) {
      return roidValue;
    }

    // Parse ROID format: [Type 2 chars][7 digits][4 digits][2 digits]
    // Example: At0000057000102 → At.0000057.0000.02
    const match = roidValue.match(/^([A-Za-z]{2})(\d{7})(\d{4})(\d{2})$/);
    if (match) {
      const [, type, segment1, segment2, segment3] = match;
      return `${type}.${segment1}.${segment2}.${segment3}`;
    }

    // Fallback: return as-is if pattern doesn't match
    return roidValue;
  }

  return '';
};
